import React from 'react';
import { SvgWithColorProps } from '../interfaces';

const SVGCardRock = ({ color }: SvgWithColorProps) => (
  <svg
    width='32'
    height='35'
    viewBox='0 0 32 35'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M21.9879 34.5285L10.6766 34.1946L0.49691 24.1078L0.0732422 11.5798L1.78533 9.88136L5.77825 9.99075L5.49387 1.63685L7.14212 0.0132751L12.5918 0.22054L14.0427 1.98229L29.0162 4.69975L30.7399 6.40393L31.5872 25.0059L21.9879 34.5285ZM11.6632 31.9205L21.0535 32.1968L29.2193 24.0905L28.459 7.39419L27.8844 6.82421L12.7891 4.08947L11.46 2.47742L8.0707 2.35076L7.85597 2.56378L8.33767 16.8074L6.0162 16.8823L5.8595 12.2994L2.71972 12.2131L2.42373 12.5067L2.78356 23.1233L11.6632 31.9262V31.9205Z'
      fill={color}
    />
  </svg>
);

export default SVGCardRock;
